module.exports = "/images/tray.png?259a0700a91c26b696298b1bc31dd1ed";